import { Box, Button, Grid, IconButton } from "@material-ui/core";
import { Delete as DeleteIcon } from "@material-ui/icons";
import React from "react";
import { Header, Table } from "../../../../../components";
import { useRequestContext } from "../../../../../context";

type Props = {
  visible: boolean;
};

export const UsersList: React.FC<Props> = (props) => {
  const [requestContextState, requestContextDispatch] = useRequestContext();

  // Handlers

  function handleAddUserButtonClick(): void {
    requestContextDispatch({
      type: "set-step",
      name: "user-information",
      view: "users-list",
    });
  }

  function handleDeleteUserButtonClick(email: string): void {
    requestContextDispatch({
      type: "remove-user",
      email,
    });
    // if (!next_users.length) {
    //   // This could depend on request type, that might change upon user deletion
    //   requestContextDispatch({
    //       type: "set-step",
    //       name: "user-information",
    //       view: "users-list"
    //   })
    // }
  }

  // Helpers

  function getTitle(): string {
    return `User${requestContextState.values.users.length > 1 ? "s" : ""}`;
  }

  return props.visible ? (
    <React.Fragment>
      <Grid container spacing={2} component={Box} pt={4} pb={2}>
        <Grid item xs={12}>
          <Header title={getTitle()}></Header>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} component={Box} display="flex">
          <Table
            columns={[
              { label: "Email Address" },
              { label: "Name" },
              { label: "Employee ID" },
              { label: "", width: "58px" },
            ]}
            rowHeight={43}
          >
            {requestContextState.values.users.map((user) => (
              <Table.Row key={user.email}>
                <Table.Cell>{user.email}</Table.Cell>
                <Table.Cell>{user.name}</Table.Cell>
                <Table.Cell>{user.id}</Table.Cell>
                <Table.Cell>
                  <IconButton
                    size="small"
                    onClick={() => handleDeleteUserButtonClick(user.email)}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Table.Cell>
              </Table.Row>
            ))}
          </Table>
        </Grid>
        <Grid item xs={12}>
          <Button variant="outlined" onClick={handleAddUserButtonClick}>
            + Add User
          </Button>
        </Grid>
      </Grid>
    </React.Fragment>
  ) : null;
};
